import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import Select from 'react-select';
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleChangeSelect,
    handleSubmit,
    isLoading,
    validate,
    dataList,
    dataListSelected
}) => {
    const { title, data } = formAttribute;
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white" />
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupKode">
                        <Form.Label>ID Siswa (NISN)</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vckode} 
                            onChange={(event) => handleChange(event)} 
                            name="vckode" 
                            placeholder="Kode"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            ID Siswa tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnama}
                            onChange={(event) => handleChange(event)}
                            name="vcnama"
                            placeholder="Nama" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupAlamatSiswa">
                        <Form.Label>Alamat</Form.Label>
                        <Form.Control
                            as="textarea" 
                            rows={2}
                            value={data?.vcalamat}
                            onChange={(event) => handleChange(event)}
                            name="vcalamat"
                            placeholder="Alamat" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Alamat tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupGender">
                        <Form.Label>Jenis Kelamin</Form.Label>
                        <Form.Select value={data?.intsex} onChange={(event) => handleChange(event)} name="intsex" required>
                            <option value=''>Pilih Jenis Kelamin</option>
                            <option value={1}>Laki - Laki</option>
                            <option value={2}>Perempuan</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Jenis Kelamin tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupSchool">
                        <Form.Label>Sekolah</Form.Label>
                        <Select
                            options={dataList.school}
                            placeholder='Pilih Sekolah'
                            classNamePrefix="react-select"
                            value={dataListSelected.school}
                            onChange={(value) => handleChangeSelect(value, 'intsekolah', 'school')}
                        />
                        <Form.Control.Feedback type="invalid">
                            Sekolah tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupClass">
                        <Form.Label>Kelas</Form.Label>
                        <Select
                            options={dataList.class}
                            placeholder='Pilih Kelas'
                            classNamePrefix="react-select"
                            value={dataListSelected.class}
                            onChange={(value) => handleChangeSelect(value, 'intkelas', 'class')}
                        />
                        <Form.Control.Feedback type="invalid">
                            Kelas tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupParent">
                        <Form.Label>Nama Orang Tua / Wali</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnamaortuwali}
                            onChange={(event) => handleChange(event)}
                            name="vcnamaortuwali"
                            placeholder="Nama Orang Tua / Wali" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama Orang Tua / Wali tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupParent">
                        <Form.Label>Nomor Telepon Orang Tua / Wali</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vctelportuwali}
                            onChange={(event) => handleChange(event)}
                            name="vctelportuwali"
                            placeholder="Nomor Telepon Orang Tua / Wali" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nomor Telepon Orang Tua / Wali tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>
                    
                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;